// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__33rMn","clinicsSelect":"TableHeading_clinicsSelect__2UmOJ"};